import { render, staticRenderFns } from "./TopSellProduct.vue?vue&type=template&id=34674776"
import script from "./TopSellProduct.vue?vue&type=script&lang=js"
export * from "./TopSellProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports